// Librerías de Angular
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// Entidades relacionadas con Fiduciaria
import { DependenciesDto, Dependency } from "@fiduciaria/Shared/Types/dependency.interface";
import { Escrow, EscrowDto } from "@fiduciaria/Shared/Types/escrow.interface";
import { map, Observable } from "rxjs";

// Configuración de entorno
import { environment } from "@environments/environment";

// Entidades relacionadas con el usuario corporativo (Fiduciaria)
import { FiduciariaPermisosRole } from "@shared/Entities/Fiduciaria/FiduciariaPermisosRole.entity";
import { UsuarioCorporativoFiduciaria } from "@shared/Entities/Fiduciaria/usuarioCorporativoFiduciaria";

const { enlineaBackendUrl } = environment;
@Injectable({
  providedIn: "root",
})
export class CanalesUserFiduciaryRepository {
  [x: string]: any;
  constructor(private readonly http: HttpClient) {}

  public getAllUsersFilter<
    T extends {
      nombres?: string;
      apellidos?: string;
      desde?: any;
      hasta?: any;
      identificacion?: string;
      activo?: boolean;
      perfil?: any;
      rol?: any;
    }
  >(
    pageSize: number = 10,
    pageNumber: number = 1,
    maxPages: number = 10,
    filterOptions?: T,
    spinner: boolean = true
  ): Observable<any> {
    if (filterOptions && Object.keys(filterOptions).length > 0)
      filterOptions = {
        ...filterOptions,
        desde: filterOptions.desde ? (filterOptions.desde as Date).toISOString() : undefined,
        hasta: filterOptions.hasta ? (filterOptions.hasta as Date).toISOString() : undefined,
        perfil: filterOptions.perfil ? filterOptions.perfil.id : undefined,
        rol: filterOptions.rol ? filterOptions.rol.id : undefined,
      };

    let url = `${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/GetAllPaginado?spinner=${spinner}&pageSize=${pageSize}&pageNumber=${pageNumber}&maxPages=${maxPages}`;
    for (const a in filterOptions) {
      if (filterOptions[a] !== undefined) {
        url += `&${this.capitalizeFirstLetter(a)}=${filterOptions[a]}`;
      }
    }

    return this.http.get(url);
  }

  public getAdministradoresClientesCorporativos(): Observable<UsuarioCorporativoFiduciaria[]> {
    return this.http.get<UsuarioCorporativoFiduciaria[]>(
      `${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/UsuariosOperativosFiduciaria`
    );
  }

  public getUserFideicomisos(): Observable<Escrow[]> {
    return this.http.get<Escrow[]>(`${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/ObtenerFideicomisos`);
  }

  public getUserFideicomisosByUserId(userId: number): Observable<Escrow[]> {
    return this.http.get<Escrow[]>(
      `${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/ObtenerFideicomisosByUserId/${userId}`
    );
  }

  public getAreasByIdFideicomiso(idFideicomiso: number): Observable<Dependency[]> {
    return this.http.get<Dependency[]>(`${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/ObtenerAreas/${idFideicomiso}`);
  }

  public getEscrows(): Observable<Escrow[]> {
    return this.http.get<EscrowDto>(`${enlineaBackendUrl}/api/bizagi/Fiduciary/Escrows/All`).pipe(map(({ pgIdent }) => pgIdent));
  }

  public getDependencies(): Observable<Dependency[]> {
    return this.http
      .get<DependenciesDto>(`${enlineaBackendUrl}/api/bizagi/Fiduciary/Dependencies`)
      .pipe(map(({ dependencia }) => dependencia));
  }

  public getFiduciariaPermisosRole(): Observable<FiduciariaPermisosRole[]> {
    return this.http.get<FiduciariaPermisosRole[]>(`${enlineaBackendUrl}/api/fiduciary/permisos`);
  }

  public getPermisosByUserId(userGuid: string): Observable<FiduciariaPermisosRole[]> {
    return this.http.get<FiduciariaPermisosRole[]>(
      `${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/ObtenerPermisosByUserId/${userGuid}`
    );
  }

  public getUsuariosAdminFiduciaria(): Observable<UsuarioCorporativoFiduciaria[]> {
    return this.http.get<UsuarioCorporativoFiduciaria[]>(
      `${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/UsuariosAdminFiduciaria`
    );
  }

  public getUserFiduciary(userGuid: string): Observable<FiduciariaPermisosRole> {
    return this.http.get<FiduciariaPermisosRole>(`${enlineaBackendUrl}/api/fiduciaria/FiduciariaUsuarios/${userGuid}`);
  }
}
